export const EMPLOYEES_ROUTE = '/production/employees'
export const EMPLOYEE_PAYROLL_ROUTE =
  '/production/employees/:employeeId/payroll'
export const FINANCE_PAYROLL_ROUTE = '/finance/payroll'
export const FINANCE_EMPLOYEE_PAYROLL_ROUTE =
  '/finance/payroll/employees/:employeeId'

export const getPayrollListDestination = (params: URLSearchParams) => {
  const nextParams = new URLSearchParams(params)
  nextParams.set('mode', 'payroll')

  return {
    pathname: EMPLOYEES_ROUTE,
    search: `?${nextParams.toString()}`,
  }
}

export const getPayrollEmployeeDestination = (
  employeeId: string,
  params: URLSearchParams,
) => {
  const search = params.toString()

  return {
    pathname: `${EMPLOYEES_ROUTE}/${encodeURIComponent(employeeId)}/payroll`,
    search: search ? `?${search}` : '',
  }
}
